module.exports = __webpack_public_path__ + "static/gufs_logo2@2x-e180d37811bdbba8abe0f916132a867c.png";